import type { CompanyVatTypeDto } from '@eneco/dc-be/client/types.gen';

export const VAT_STATUS_VAT_REQUIRED = 'VatRequired' satisfies CompanyVatTypeDto;
export const VAT_STATUS_VAT_NOT_REQUIRED = 'VatNotRequired' satisfies CompanyVatTypeDto;
export const VAT_STATUS_COMPANY_NUMBER_REQUESTED = 'CompanyNumberRequested' satisfies CompanyVatTypeDto;

export type VatStatusOption =
  | typeof VAT_STATUS_VAT_REQUIRED
  | typeof VAT_STATUS_VAT_NOT_REQUIRED
  | typeof VAT_STATUS_COMPANY_NUMBER_REQUESTED;

export const isCompanyNumberRequested = (vatStatus?: string | null): boolean =>
  vatStatus === VAT_STATUS_COMPANY_NUMBER_REQUESTED;

export const mapVatStatusToSubjectToVAT = (vatStatus?: string | null): boolean | null => {
  if (vatStatus === VAT_STATUS_VAT_REQUIRED) return true;
  if (vatStatus === VAT_STATUS_VAT_NOT_REQUIRED) return false;
  if (vatStatus === VAT_STATUS_COMPANY_NUMBER_REQUESTED) return false;
  return false;
};

export const resolveVatStatusFromCompanyDetails = (companyDetails: {
  companyNumberIsBeingRequested?: boolean | null;
  subjectToVAT?: boolean | null;
  vatType?: CompanyVatTypeDto | null;
}): VatStatusOption | undefined => {
  if (companyDetails.companyNumberIsBeingRequested || companyDetails.vatType === VAT_STATUS_COMPANY_NUMBER_REQUESTED) {
    return VAT_STATUS_COMPANY_NUMBER_REQUESTED;
  }
  if (companyDetails.vatType === VAT_STATUS_VAT_REQUIRED || companyDetails.subjectToVAT === true) {
    return VAT_STATUS_VAT_REQUIRED;
  }
  if (companyDetails.vatType === VAT_STATUS_VAT_NOT_REQUIRED || companyDetails.subjectToVAT === false) {
    return VAT_STATUS_VAT_NOT_REQUIRED;
  }
  return undefined;
};
